export const environment: any = {
  production: true,
  authenticated: false,
  hmr: false,
  apiUrl: 'http://backend.spas.local:8085/api/v1',
  backendUrl: 'http://backend.spas.local:8085', // frontend.spas.local | backend.spas.local
  dataCardDocUrl: 'https://valid.okea.no/tags/DRA',
  useAD: false, // true | false Use Active Directory to login
  useAzureAD: true, // true | false Use Azure Active Directory to login
  weeksAhead: 6, // number - for N Week Ahead Report
  userManualUrl: '#',
  acrAppUrl: 'https://acr.zeeksolutions.no',
  activateQueryBuilder: true,
  copyright: {
    application: 'SPAS',
    company: 'Zeek Solutions AS',
    url: 'https://zeek-solutions.no/',
  }
}
